import(/* webpackMode: "eager" */ "/builds/tradingvalley-frontend/growin/apps/web/app/[lang]/(home)/home.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/tradingvalley-frontend/growin/apps/web/layouts/footer/components/FooterLinks.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Navbar"] */ "/builds/tradingvalley-frontend/growin/apps/web/layouts/navbar/components/Navbar.tsx");
;
import(/* webpackMode: "eager" */ "/builds/tradingvalley-frontend/growin/node_modules/next/dist/client/link.js");
